import { ascending, descending } from "d3-array";
import { hasKey } from "../../exports/helpers.js";
export default function sortValues(data, key, order, locale) {
    let keysToSort;
    if (typeof key === "string") {
        keysToSort = [key];
    }
    else if (Array.isArray(key)) {
        keysToSort = key;
    }
    else {
        throw new Error("key must be a string or an array of strings.");
    }
    let locales = [];
    if (locale) {
        if (typeof locale === "string") {
            locales = [locale];
        }
        else if (Array.isArray(locale)) {
            locales = locale;
        }
    }
    for (const key of keysToSort) {
        hasKey(data, key);
    }
    if (order === "ascending") {
        for (let i = keysToSort.length - 1; i >= 0; i--) {
            const key = keysToSort[i];
            const locale = locales[i];
            if (typeof locale === "string") {
                data.sort((a, b) => a[key].localeCompare(b[key], locale));
            }
            else {
                data.sort((a, b) => ascending(a[key], b[key]));
            }
        }
    }
    else if (order === "descending") {
        for (let i = keysToSort.length - 1; i >= 0; i--) {
            const key = keysToSort[i];
            const locale = locales[i];
            if (typeof locale === "string") {
                data.sort((a, b) => b[key].localeCompare(a[key], locale));
            }
            else {
                data.sort((a, b) => descending(a[key], b[key]));
            }
        }
    }
    else {
        throw new Error("The order must be either ascending or descending.");
    }
    return data;
}
//# sourceMappingURL=sortValues.js.map